import React from 'react';

const sectionStyle = "mb-10";
const titleStyle = "text-[20px] md:text-[22px] font-semibold tracking-wide uppercase mb-4";
const paragraphStyle = "text-[15px] leading-[28px] font-light text-[#2A2A2A]";

const PoliciesPage = () => {
  return (
    <div className="bg-[#f9f7f4] min-h-screen py-16 px-6 md:px-12 text-[#2A2A2A] font-['Helvetica Neue','Arial','sans-serif']">
      <div className="max-w-3xl mx-auto space-y-12">

        <h1 className="text-4xl font-light tracking-widest uppercase text-center mb-10">Policies</h1>

        {/* Shipping */}
        <div className={sectionStyle}>
          <h2 className={titleStyle}>Shipping Policy</h2>
          <p className={paragraphStyle}>
            We offer <strong>free delivery on selected products</strong> to all cities within Iraq. Orders typically arrive within <strong>7–15 business days</strong> after placement. All deliveries are tracked, and you will receive a tracking number after shipment.
          </p>
        </div>

        {/* Returns */}
        <div className={sectionStyle}>
          <h2 className={titleStyle}>Return & Exchange</h2>
          <p className={paragraphStyle}>
            MORY accepts returns or exchanges within <strong>5 days</strong> of receiving your order. Items must be in original condition, unused, undamaged, and accompanied by original packaging and certificates. Customized and engraved items are final sale. Contact us at:
          </p>
          <ul className="mt-2 ml-4 list-disc text-[15px] leading-7">
            <li>WhatsApp: <a href="https://wa.me/9647514141213" className="underline">+964 751 414 1213</a></li>
            <li>Email: <a href="mailto:info@mory-gold.com" className="underline">info@mory-gold.com</a></li>
          </ul>
        </div>

        {/* Warranty */}
<div className={sectionStyle}>
  <h2 className={titleStyle}>Warranty</h2>
  <p className={paragraphStyle}>
    At MORY, we offer an optional <strong>1-Year Jewelry Warranty</strong> for a small fee of <strong>$5</strong>. This warranty can be added during checkout and provides protection against:
  </p>
  <ul className="mt-2 ml-4 list-disc text-[15px] leading-7">
    <li>Manufacturing defects</li>
    <li>Loose stones, pearls, or settings</li>
    <li>Broken locks, clasps, or joints</li>
  </ul>
  <p className={`${paragraphStyle} mt-4`}>
    The warranty covers repairs or replacements for eligible issues at no additional cost. It does not cover lost items, damage due to misuse, or normal wear and tear. 
  </p>
  <p className={`${paragraphStyle} mt-2`}>
    If you choose not to include the warranty at checkout, any repairs will be subject to standard service fees.
  </p>
</div>


        {/* Privacy */}
        <div className={sectionStyle}>
          <h2 className={titleStyle}>Privacy Policy</h2>
          <p className={paragraphStyle}>
            Your personal data (name, phone, address, email) is securely stored and used only for order processing and support. We never share or sell your data. Payments are processed via secure gateways; we don’t store your card details.
          </p>
        </div>

        {/* Terms */}
        <div className={sectionStyle}>
          <h2 className={titleStyle}>Terms of Service</h2>
          <p className={paragraphStyle}>
            By using our website or placing an order, you agree to our terms. We reserve the right to change product info, cancel suspicious orders, and update policies without notice. All content on this site belongs to MORY and may not be reproduced.
          </p>
        </div>

        {/* Care Instructions */}
        <div className={sectionStyle}>
          <h2 className={titleStyle}>Jewelry Care</h2>
          <p className={paragraphStyle}>
            Store pieces separately to prevent scratches. Avoid perfumes, lotions, and chemicals. Clean with a soft cloth regularly. Remove jewelry before workouts or swimming for longevity.
          </p>
        </div>

      </div>
    </div>
  );
};

export default PoliciesPage;
